const SLOT_NAME_APPEND = 'append';
const SLOT_NAME_BOTTOM_ROW = 'bottom-row';
const SLOT_NAME_BUTTON_CONTENT = 'button-content';
const SLOT_NAME_CUSTOM_FOOT = 'custom-foot';
const SLOT_NAME_DEFAULT = 'default';
const SLOT_NAME_DESCRIPTION = 'description';
const SLOT_NAME_EMPTY = 'empty';
const SLOT_NAME_EMPTYFILTERED = 'emptyfiltered';
const SLOT_NAME_FIRST = 'first';
const SLOT_NAME_HEADER = 'header';
const SLOT_NAME_INVALID_FEEDBACK = 'invalid-feedback';
const SLOT_NAME_LABEL = 'label';
const SLOT_NAME_MODAL_BACKDROP = 'modal-backdrop';
const SLOT_NAME_MODAL_CANCEL = 'modal-cancel';
const SLOT_NAME_MODAL_FOOTER = 'modal-footer';
const SLOT_NAME_MODAL_HEADER = 'modal-header';
const SLOT_NAME_MODAL_HEADER_CLOSE = 'modal-header-close';
const SLOT_NAME_MODAL_OK = 'modal-ok';
const SLOT_NAME_MODAL_TITLE = 'modal-title';
const SLOT_NAME_PREPEND = 'prepend';
const SLOT_NAME_ROW_DETAILS = 'row-details';
const SLOT_NAME_TABLE_BUSY = 'table-busy';
const SLOT_NAME_TABLE_CAPTION = 'table-caption';
const SLOT_NAME_TABLE_COLGROUP = 'table-colgroup';
const SLOT_NAME_TABS_END = 'tabs-end';
const SLOT_NAME_TABS_START = 'tabs-start';
const SLOT_NAME_TOOLBAR_END = 'toolbar-end';
const SLOT_NAME_TOOLBAR_START = 'toolbar-start';
const SLOT_NAME_TEXT = 'text';
const SLOT_NAME_THEAD_TOP = 'thead-top';
const SLOT_NAME_TITLE = 'title';
const SLOT_NAME_TOAST_TITLE = 'toast-title';
const SLOT_NAME_TOP_ROW = 'top-row';
const SLOT_NAME_VALID_FEEDBACK = 'valid-feedback';

export { SLOT_NAME_APPEND, SLOT_NAME_BOTTOM_ROW, SLOT_NAME_BUTTON_CONTENT, SLOT_NAME_CUSTOM_FOOT, SLOT_NAME_DEFAULT, SLOT_NAME_DESCRIPTION, SLOT_NAME_EMPTY, SLOT_NAME_EMPTYFILTERED, SLOT_NAME_FIRST, SLOT_NAME_HEADER, SLOT_NAME_INVALID_FEEDBACK, SLOT_NAME_LABEL, SLOT_NAME_MODAL_BACKDROP, SLOT_NAME_MODAL_CANCEL, SLOT_NAME_MODAL_FOOTER, SLOT_NAME_MODAL_HEADER, SLOT_NAME_MODAL_HEADER_CLOSE, SLOT_NAME_MODAL_OK, SLOT_NAME_MODAL_TITLE, SLOT_NAME_PREPEND, SLOT_NAME_ROW_DETAILS, SLOT_NAME_TABLE_BUSY, SLOT_NAME_TABLE_CAPTION, SLOT_NAME_TABLE_COLGROUP, SLOT_NAME_TABS_END, SLOT_NAME_TABS_START, SLOT_NAME_TEXT, SLOT_NAME_THEAD_TOP, SLOT_NAME_TITLE, SLOT_NAME_TOAST_TITLE, SLOT_NAME_TOOLBAR_END, SLOT_NAME_TOOLBAR_START, SLOT_NAME_TOP_ROW, SLOT_NAME_VALID_FEEDBACK };
